import React from "react";
import Header from "./components/header";
import styles from './index.module.scss'
import List from "./components/list";
import Transfer from "./components/transfer";
import { useGetBalanceData, useUserInfo, useVenueBalanceList } from "@/api/request";
import LoadingUI from "@/compoments/loadingUI";

const TransferCenter = () => {
    const { isLoading: loadingVenueBlance } = useVenueBalanceList()
    const { isLoading: loadingBalance } = useGetBalanceData()
    const { isLoading: loadingUser} = useUserInfo()

    return <div className={styles.warpper}>

        <LoadingUI loading={loadingVenueBlance || loadingBalance || loadingUser} height={807} data={[1]}>
            <div>
                <Header />
            </div>

            <div className={styles.list}>
                <List />
            </div>

            <div className={styles.transfer}>
                <Transfer />
            </div>
        </LoadingUI>

    </div>
}

export default TransferCenter